{
  "slug": "does-sleep-affect-iq",
  "title": "睡眠是否影响智商测试的表现?",
  "description": "睡眠不足会影响注意力、记忆力、速度和一致性。",
  "category": "智商问题答案",
  "sections": [
    {
      "heading": "简短答复",
      "paragraphs": ["睡眠不足会影响注意力、记忆力、速度和一致性。"]
    },
    {
      "heading": "什么影响它",
      "paragraphs": [
        "测试质量、年龄、健康、语言、教育、动机、环境和目的都很重要。",
        "平均研究效果不能准确预测一个人。"
      ]
    },
    {
      "heading": "指导",
      "paragraphs": [
        "使用足够的睡眠,安静的条件,住宿,和一个合适的仪器。",
        "对于儿童、健康、残疾或高风险决策,请咨询合格的专业人士。"
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "睡眠不足会影响注意力、记忆力、速度和一致性。 18 七月 2026."
}
